interface StatsBarProps {
  content: {
    readonly stats: readonly {
      readonly number: string;
      readonly label: string;
    }[];
  };
}
const StatsBar = ({
  content
}: StatsBarProps) => {
  return <section className="py-8 bg-white backdrop-blur-sm border-y border-border/50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            {content.stats.map((stat, index) => <div key={index} className="space-y-2">
                <div className="text-3xl md:text-4xl font-bold text-gray-400 bg-transparent">
                  {stat.number}
                </div>
                <div className="text-sm md:text-base text-muted-foreground">
                  {stat.label}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};
export default StatsBar;